export default {
  Dot: '.',
  Comma: ',',
};
